@use '../common/colors.scss' as colors;
@use '../common/vars.scss' as vars;

.invalid-address-wrapper {
  padding: 0 6px;
  width: 100%;
}

:global(.header-txt).invalid-address-title {
  text-align: center;
  margin: 32px 0;
  line-height: 33px;

  h1 {
    font-size: 1em;
    letter-spacing: -0.1px;
  }

  @media screen and (max-width: vars.$mobile) {
    font-size: 24px;
  }
}

.invalid-address-select-option {
  margin: 24px 0;
}

.invalid-address-radio-group {
  margin-bottom: 15px;
}

.invalid-address-radio-button :global(.MuiFormControlLabel-root) {
  margin: 5px 0;

  span:first-of-type {
    padding: 0 6px 0 0;
  }

  span {
    font-size: 0.85em !important;
    font-weight: 500 !important;
  }
}

.invalid-address-inputs {
  display: flex;
  flex-wrap: wrap;

  & > * {
    width: 100%;
    padding: 0 6px;
  }
}

.invalid-address-input-half {
  width: 50%;
}

.invalid-address-input-half-desktop {
  width: 50%;

  @media screen and (max-width: vars.$mobile) {
    width: 100%;
  }
}

.invalid-address-form-submit {
  margin-bottom: 10px;
  font-size: 1.125em;
  padding: 10px 16px;
}

.invalid-address-form-submit:global(.disabled) {
  opacity: 0.1;
  cursor: not-allowed;
}

// Flexpay
:global(.flexpay) {
  :global(.header-txt).invalid-address-title {
    line-height: 24px;
  }

  .invalid-address-title {
    text-align: left;
  }

  .invalid-address-form-submit {
    padding: 18px 0;
    margin-top: 9px;
    max-width: 290px;
  }

  .invalid-address-radio-group :global(.Mui-checked) {
    color: colors.$flexpay-link;
  }

  @media screen and (max-width: vars.$mobile) {
    .invalid-address-form-submit {
      max-width: 100%;
    }

    .invalid-address-title {
      font-size: 20px;
    }
  }
}
